import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toast"]
  static values = { url: String }

  copy() {
    navigator.clipboard.writeText(this.urlValue).then(() => {
      document.getElementById("toasts").appendChild(this.toastTarget.content.cloneNode(true))
      $(this.element.closest(".modal")).modal("hide")
    })
  }
}
